<script >
import bem from '@/utils/bem';

const b = bem('new-check-button');

export default {
  props: [
    'classNameCheckedToggle',
    'checked',
    'firstText',
    'textChecked',
    'isSmall',
  ],
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
  },
};
</script>

<template>
  <div
      :class="b('', { on: checked, small: isSmall })"
  >
    <div :class="b('toggle-on', {mix: classNameCheckedToggle})" v-if="checked">
      <img
          :class="b('toggle-on-icon')"
          src="@/assets/images/selected.svg"
          alt='download'
      />
    </div>
    <span>{{checked ? textChecked : firstText}}</span>
  </div>
</template>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/media";
@import "@/styles/fonts";

.new-check-button {
  width: 322px;
  height: 52px;
  border: solid 1px $jagged_ice;
  background-color: $white-color;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 24px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: 18px;
  letter-spacing: normal;
  text-align: center;
  color: $horizon;

  &_on {
    padding-left: 5px;

    @include mediaMinMax(1025, $normal) {
      padding-left: vw-full(5);
    }
  }

  @include mediaMinMax(1025, $normal) {
    font-size: vw-full(18);
    width: vw-full(322);
    height: vw-full(52);
    margin-bottom: vw-full(11);
  }

  @include media($xsmall) {
    width: 168px;
    height: 40px;
    margin-bottom: 7px;
  }

  &_small {
    width: 201px;
    margin-bottom: 0;
    height: 50px;

    @include mediaMinMax(1025, $normal) {
      width: vw-full(201);
      height: vw-full(50);
    }

    @include media($xsmall) {
      width: 168px;
      height: 39px;
      margin-bottom: 7px;
    }
  }

  &_select {
    border: 3px solid $tacao;
  }

  span {
    flex-grow: 1;
  }

  &__toggle-on {
    width: 42px;
    height: 42px;
    background-color: $white-color;

    @include mediaMinMax(1025, $normal) {
      width: vw-full(42);
      height: vw-full(42);
    }

    @include mediaMinMax(481, $small) {
      width: vw-mobile(32);
      height: vw-mobile(32);
    }

    @include media($mini) {
      width: 32px;
      height: 32px;
    }
  }

  &__toggle-on {
    background-color: $horizon;
  }

  &__toggle-on-icon {
    width: 42px;
    height: 42px;

    @include mediaMinMax(1025, $normal) {
      width: vw-full(42);
      height: vw-full(42);
    }

    @include mediaMinMax(481, $small) {
      width: vw-mobile(32);
      height: vw-mobile(32);
    }

    @include media($mini) {
      width: 32px;
      height: 32px;
    }
  }
}
</style>
